import { createFileRoute } from '@tanstack/react-router';
import { SearchTermsPage } from '@/pages/SearchTermsPage';

export const Route = createFileRoute('/_authed/search-terms')({
  component: SearchTermsPage,
});
